export const getSetCurrentShopConfigChargeLimitPayload = (values) => {
    if (!values.setChargeLimit) {
        return {
            chargePolicy: {
                type: 'NO_LIMIT',
            },
        };
    }
    return {
        chargePolicy: {
            type: 'LIMITED',
            amount: {
                currency: 'USD',
                value: parseFloat(values.chargeLimit),
            },
        },
    };
};
